import React, { useEffect, useRef, useState } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { usePathname, useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { storeFront } from '@/lib/utils/routeLinks';

interface HeaderOnlineShopSearchProps {
  focusActive?: boolean;
}

export default function HeaderOnlineShopSearch(
  props: HeaderOnlineShopSearchProps
) {
  const { focusActive } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const router = useRouter();
  const t = useTranslations();
  const pathname = usePathname();
  const [query, setQuery] = useState<string>('');

  useEffect(() => {
    if (focusActive && inputRef && inputRef?.current) {
      inputRef.current?.focus();
    }
  }, [focusActive, inputRef]);

  const redirectURL = storeFront.restaurants.de();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const handleSearch = () => {
    if (query.trim()) {
      window.location.href = `${redirectURL}?search=${encodeURIComponent(
        query.trim()
      )}`;
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch();
  };

  if (pathname.endsWith(redirectURL)) {
    return;
  }

  return (
    <form
      role="search"
      aria-label="Search online shop"
      onSubmit={handleSubmit}
      className="max-w-md xl:ml-3 xl:w-full"
    >
      <div className="relative">
        <button
          type="button"
          onClick={handleSearch}
          className="absolute inset-y-0 start-0 flex items-center focus:outline-none"
          aria-label="Trigger search"
        >
          <MagnifyingGlassIcon className="h-6 w-6 text-gray-400" />
        </button>

        <input
          type="search"
          name="keyword"
          value={query}
          onChange={handleInputChange}
          placeholder={t('search')}
          aria-label="Search online shop"
          className="right-0 w-full border-0 border-b-[2px] border-gray-200 bg-transparent py-2 pl-8 pr-4 outline-0 focus:border-gray-200 focus:outline-none focus:ring-0"
          // className="w-full rounded-full border-0 bg-white py-3 pl-10 pr-4 shadow-[0px_14px_70px_rgba(0,0,0,0.1)] outline-0 focus:border-0 focus:ring-0"
          ref={inputRef}
        />
      </div>
    </form>
  );
}
